import type { MeResponse, Tenant, UpdateTenant } from '@servicetim/shared';
import { useMutation, useQuery } from '@tanstack/react-query';
import { adminPath, useApiContext } from './client';

/** `GET /admin/v1/tenant` */
export function useTenant() {
  const { request, keys } = useApiContext();
  return useQuery({
    queryKey: keys.tenant,
    queryFn: ({ signal }) => request<Tenant>('GET', adminPath('/tenant'), { signal }),
  });
}

/** `PATCH /admin/v1/tenant` (tenant admin). */
export function useUpdateTenant() {
  const { request, keys, invalidate } = useApiContext();
  return useMutation({
    mutationFn: (patch: UpdateTenant) =>
      request<Tenant>('PATCH', adminPath('/tenant'), { body: patch }),
    onSuccess: () => invalidate(keys.tenant, keys.me),
  });
}

/** `GET /admin/v1/me`: caller, tenant, tenant role, groups, organizations. */
export function useMe() {
  const { request, keys } = useApiContext();
  return useQuery({
    queryKey: keys.me,
    queryFn: ({ signal }) => request<MeResponse>('GET', adminPath('/me'), { signal }),
    staleTime: 5 * 60_000,
  });
}
